import { Container } from '@mui/material';

const AuthLayout = (props: any) => {
  return (
    <Container
      maxWidth={false}
      sx={{
        backgroundColor: 'background.paper',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
        height: '100vh'
      }}
    >
      {props.children}
    </Container>
  );
};

export default AuthLayout;
